export default function getTabId() {
    let id = sessionStorage.getItem('tabId');
    if (!id) {
        id = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2));
        sessionStorage.setItem('tabId', id);
    }

    return id;
}